require('./command.js');

(function(){
  PegasusTemplate.RotateRowCommand = PegasusTemplate.Command.extend({
    klass: null,
    backup: null,
    callback: null,
    parent: function(){
      return PegasusTemplate.blockRegionInstance;
    }.property(),
    descriptionClass: 'moved',
    description: function(){
      return Em.I18n.t('command_descriptions.moved_content');
    }.property(),
    childPosition: null,
    execute: function() {
      var callback = this.get('callback'),
        parent = this.get('parent').objectAt( this.get('childPosition') ),
        orphans = [],
        parents = [],
        p, c;

      parent.get('blocks').forEach(function(block){
        orphans.push(block);
        p = block.get('parentView');
        parents.push(p);
        p.get('childViews').removeObject( block );
      });

      parents.forEach(function(adopter, i){
        c = orphans[i + 1]
        if ( ! c ) {
          c = orphans[0];
        }
        adopter.get('childViews').addObject( c );
      });

      parents.invoke('rerender');

      if ( callback ) {
        callback();
      }

      this._super();
    },

    unexecute: function(callback){
      var parent = this.get('parent'),
        child = parent.objectAt( this.get('childPosition') ),
        reborn = PegasusTemplate.RegionView.create({
          container: parent.container,
          sourceElement: this.get('backup')
        });

      parent.removeObject( child );
      parent.insertAt( this.get('childPosition'), reborn );

      this._super();
    }
  });
})();

